<template>
  <div>
    <InfosCommercial/>
    <ActionsDownload/>
    <Concurrent/>
  </div>
</template>

<script>
import Concurrent from '@/components/portail/concurrent/concurrent';
import InfosCommercial from './blocInfos/InfosCommercial';
import ActionsDownload from './blocInfos/ActionsDownload';

export default {
  components: {
    InfosCommercial,
    ActionsDownload,
    Concurrent,
  },
  computed: {
  },
};
</script>

<style>

</style>